import React, { useState } from "react";
import "../styles/header.css";
import logo1 from "../assets/logo1.png";
import { FaRegHeart, FaSearch, FaHeart } from "react-icons/fa";
import { IoMdHeartDislike } from "react-icons/io";
import { TiThMenu } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import FilterModal from "./FilterModal";
import { useFavorites } from "./Context/FavoritesContext";
import { Link } from "react-router-dom";

import { Snackbar, Alert } from "@mui/material";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFavoriteMenuOpen, setIsFavoriteMenuOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);

  const {
    favorites,
    addFavorite,
    removeFavorite,
    isFilterModalOpen,
    setIsFilterModalOpen,
  } = useFavorites();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev);
  };

  const toggleFavoriteMenu = () => {
    setIsFavoriteMenuOpen(!isFavoriteMenuOpen);
  };

  const handleAddFavorite = (property) => {
    addFavorite(property);
    setToastOpen(true);
  };

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header__inner">
          <div className="header__logo">
            <Link to="/">
              <img src={logo1} alt="Senna Viannini Imóveis" />
            </Link>
          </div>

          <button
            type="button"
            className="header__search"
            onClick={toggleFilterModal}
            aria-haspopup="dialog"
            aria-expanded={isFilterModalOpen}
          >
            <FaSearch className="header__search-icon" aria-hidden="true" />
            <span className="header__search-label">Pesquise o imóvel perfeito</span>
          </button>

          <div className="header__actions">
            <button
              type="button"
              className="header__action"
              onClick={toggleMenu}
              aria-label="Abrir menu"
            >
              <TiThMenu />
            </button>
            <button
              type="button"
              className="header__action"
              onClick={toggleFavoriteMenu}
              aria-label="Ver imóveis favoritos"
            >
              <FaRegHeart />
            </button>
          </div>
        </div>
      </header>

      {(isMenuOpen || isFilterModalOpen || isFavoriteMenuOpen) && (
        <div
          className="overlay-blur"
          onClick={() => {
            setIsMenuOpen(false);
            setIsFilterModalOpen(false);
            setIsFavoriteMenuOpen(false);
          }}
        ></div>
      )}

      <aside className={`side-menu ${isMenuOpen ? "open" : ""}`}>
        <div className="menu-header">
          <Link to="/">
            <img
              src={logo1}
              alt="Senna Viannini Imóveis"
              className="menu-logo"
            />
          </Link>
          <IoClose className="close-icon" onClick={toggleMenu} />
        </div>
        <ul className="menu-list">
          <Link
            onClick={() => {
              toggleFavoriteMenu();
              setIsMenuOpen(false);
            }}
            style={{
              color: "var(--verde)",
              alignItems: "center",
              display: "flex",
              gap: 10,
            }}
          >
            <FaHeart />
            <strong>Meus imóveis favoritos</strong>
          </Link>
          <h3>Imóveis</h3>
          <Link to="/todos-imoveis" onClick={() => setIsMenuOpen(false)}>
            Todos os Imóveis
          </Link>
          <Link to="/lancamentos-planta" onClick={() => setIsMenuOpen(false)}>
            Lançamentos na planta
          </Link>
          <Link to="/comprar-imovel" onClick={() => setIsMenuOpen(false)}>
            Comprar um imóvel
          </Link>
          <Link to="/alugar-imovel" onClick={() => setIsMenuOpen(false)}>
            Alugar um imóvel
          </Link>
          <h3>Entre em Contato</h3>
          <Link to="/fale-conosco" onClick={() => setIsMenuOpen(false)}>
            Fale conosco
          </Link>
          <Link to="/corretores" onClick={() => setIsMenuOpen(false)}>
            Corretores
          </Link>
        </ul>
        <button type="button" className="menu-search" onClick={toggleFilterModal}>
          <FaSearch className="search-icon" aria-hidden="true" />
          <span>Pesquise o imóvel perfeito</span>
        </button>
      </aside>

      <aside className={`favorite-menu ${isFavoriteMenuOpen ? "open" : ""}`}>
        <div className="menu-favorite">
          <img src={logo1} alt="Senna Viannini Imóveis" className="menuLogo-favorite" />
          <IoClose className="close-icon" onClick={toggleFavoriteMenu} />
        </div>
        <div className="contentFavoriteMenu">
          <h3>Meus imóveis favoritos</h3>
          {favorites.length > 0 ? (
            favorites.map((property) => (
              <div key={property.imovelInfo.codigo} className="blocoImovel">
                <button
                  onClick={() => removeFavorite(property.imovelInfo.codigo)}
                >
                  <IoMdHeartDislike className="iconUnFavorite" />
                </button>
                <img
                  src={
                    property.imagesLinks?.[0] ||
                    "https://via.placeholder.com/150"
                  }
                  alt={property.imovelInfo.titulo}
                />
                <div className="textBlocoImovel">
                  <p>Cód: {property.imovelInfo.codigo}</p>
                  <h5>{property.imovelInfo.titulo}</h5>
                  <h6>{property.informacoesComerciais.valor}</h6>
                </div>
              </div>
            ))
          ) : (
            <p>Nenhum imóvel favorito.</p>
          )}
        </div>
      </aside>

      <FilterModal isOpen={isFilterModalOpen} onClose={toggleFilterModal} />

      {/* Toast Notification com Material UI */}
      <Snackbar
        open={toastOpen}
        autoHideDuration={3000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseToast}
          severity="success"
          sx={{ width: "100%" }}
        >
          Imóvel adicionado aos favoritos!
        </Alert>
      </Snackbar>
    </>
  );
}

export default Header;
